import CreateUser from "./CreateUser";

export { CreateUser };

export default CreateUser;
